import React from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ value = 0, max = 5, size = 'sm', interactive = false, onChange, testIdPrefix }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  };

  const handleClick = (rating) => {
    if (interactive && onChange) {
      onChange(rating);
    }
  };

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].slice(0, max).map((star) => {
        const filled = star <= Math.round(value);
        return (
          <button
            key={star}
            type="button"
            disabled={!interactive}
            onClick={() => handleClick(star)}
            data-testid={testIdPrefix ? `${testIdPrefix}-${star}` : undefined}
            className={interactive ? 'cursor-pointer transition-transform hover:scale-110' : 'cursor-default'}
          >
            <Star
              className={`${sizeClasses[size]} ${filled ? 'fill-yellow-400 text-yellow-400' : 'fill-none text-slate-300'}`}
            />
          </button>
        );
      })}
    </div>
  );
}
